import * as types from '../types/index'
import axios from 'axios'
import toast from 'react-hot-toast'
import config from '../config'
import { authHeader } from '../headers'
import { admin_logout } from './adminAuthActions'
import { user_logout } from './userAuthActions'

const url = config.testUrl

export const create_submission = (obj) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.CREATE_SUBMISSION_REQUEST })

		const {
			userAuth: { userDetail },
		} = getState()

		const { data } = await axios.post(`${url}/submissions`, obj, {
			headers: authHeader(userDetail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.CREATE_SUBMISSION_SUCCESS,
				payload: data.data,
			})
			toast.success('Submission has been sent!', {
				position: 'top-right',
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(user_logout())
		}
		dispatch({ type: types.CREATE_SUBMISSION_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const get_all_user_submissions =
	(page) => async (dispatch, getState) => {
		try {
			dispatch({ type: types.ADMIN_GET_ALL_SUBMISSIONS_REQUEST })

			const {
				adminAuth: { detail },
			} = getState()

			let link = `${url}/submissions?pageNumber=${page}`

			const { data } = await axios.get(link, {
				headers: authHeader(detail.token),
			})

			if (data.status === 'ok') {
				dispatch({
					type: types.ADMIN_GET_ALL_SUBMISSIONS_SUCCESS,
					payload: data.data,
				})
				// toast.success('Campaign has been created!', {
				// 	position: 'top-right',
				// })
			}
		} catch (error) {
			const message = error.response
				? error.response.data.message
				: 'Something went wrong'
			if (message === 'Access Not Authorized' || message === 'Not Authorized') {
				dispatch(admin_logout())
			}
			dispatch({ type: types.ADMIN_GET_ALL_SUBMISSIONS_FAIL, payload: message })
			toast.error(message, { position: 'top-right' })
		}
	}

export const get_single_submission = (id) => async (dispatch, getState) => {
	try {
		dispatch({ type: types.GET_SUBMISSION_DETAILS_REQUEST })

		const {
			adminAuth: { detail },
		} = getState()

		const { data } = await axios.get(`${url}/submissions/${id}`, {
			headers: authHeader(detail.token),
		})

		if (data.status === 'ok') {
			dispatch({
				type: types.GET_SUBMISSION_DETAILS_SUCCESS,
				payload: data.data,
			})
		}
	} catch (error) {
		const message = error.response
			? error.response.data.message
			: 'Something went wrong'
		if (message === 'Access Not Authorized' || message === 'Not Authorized') {
			dispatch(admin_logout())
		}
		dispatch({ type: types.GET_SUBMISSION_DETAILS_FAIL, payload: message })
		toast.error(message, { position: 'top-right' })
	}
}

export const update_single_submission =
	(id, sub) => async (dispatch, getState) => {
		try {
			dispatch({ type: types.UPDATE_SUBMISSION_DETAILS_REQUEST })

			const {
				adminAuth: { detail },
			} = getState()

			const { data } = await axios.patch(`${url}/submissions/${id}`, sub, {
				headers: authHeader(detail.token),
			})

			if (data.status === 'ok') {
				dispatch({
					type: types.UPDATE_SUBMISSION_DETAILS_SUCCESS,
					payload: data.data,
				})
				toast.success('This entry has been updated!', {
					position: 'top-right',
				})
			}
		} catch (error) {
			const message = error.response
				? error.response.data.message
				: 'Something went wrong'
			if (message === 'Access Not Authorized' || message === 'Not Authorized') {
				dispatch(admin_logout())
			}
			dispatch({ type: types.UPDATE_SUBMISSION_DETAILS_FAIL, payload: message })
			toast.error(message, { position: 'top-right' })
		}
	}

export const user_get_all_submissions =
	(slug) => async (dispatch, getState) => {
		try {
			dispatch({ type: types.USER_GET_ALL_SUBMISSIONS_REQUEST })

			const {
				userAuth: { userDetail },
			} = getState()

			let link = `${url}/submissions/${slug}/submissions`

			const { data } = await axios.get(link, {
				headers: authHeader(userDetail.token),
			})

			if (data.status === 'ok') {
				dispatch({
					type: types.USER_GET_ALL_SUBMISSIONS_SUCCESS,
					payload: data.data,
				})
			}
		} catch (error) {
			const message = error.response
				? error.response.data.message
				: 'Something went wrong'
			if (message === 'Access Not Authorized' || message === 'Not Authorized') {
				dispatch(user_logout())
			}
			dispatch({ type: types.USER_GET_ALL_SUBMISSIONS_FAIL, payload: message })
			toast.error(message, { position: 'top-right' })
		}
	}

export const user_get_single_submission =
	(slug) => async (dispatch, getState) => {
		try {
			dispatch({ type: types.USER_GET_SUBMISSION_DETAILS_REQUEST })

			const {
				userAuth: { userDetail },
			} = getState()

			const { data } = await axios.get(`${url}/submissions/${slug}`, {
				headers: authHeader(userDetail.token),
			})

			if (data.status === 'ok') {
				dispatch({
					type: types.USER_GET_SUBMISSION_DETAILS_SUCCESS,
					payload: data.data,
				})
			}
		} catch (error) {
			const message = error.response
				? error.response.data.message
				: 'Something went wrong'
			if (message === 'Access Not Authorized' || message === 'Not Authorized') {
				dispatch(user_logout())
			}
			dispatch({
				type: types.USER_GET_SUBMISSION_DETAILS_FAIL,
				payload: message,
			})
			toast.error(message, { position: 'top-right' })
		}
	}
